import PropTypes from "prop-types";

// The white card every block of the publisher page sits in.
const SectionCard = ({ title, action, children }) => (
    <section className="rounded-xl border border-gray-200 bg-white shadow-sm">
        <header className="flex items-center justify-between gap-3 border-b border-gray-200 px-5 py-3.5">
            <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
            {action}
        </header>
        <div className="px-5 py-4">{children}</div>
    </section>
);

SectionCard.propTypes = {
    title   : PropTypes.string.isRequired,
    action  : PropTypes.node,
    children: PropTypes.node
};

export default SectionCard;
